import { render, staticRenderFns } from "./LabelVariant.vue?vue&type=template&id=58ef3062"
import script from "./LabelVariant.vue?vue&type=script&lang=js"
export * from "./LabelVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports